"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16GlobeLine = function Svg16GlobeLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0zM9.29 17.286l.031.084A6.008 6.008 0 0 1 6.083 13h2.441c.08 1.63.35 3.12.766 4.286zM10.527 13c.077 1.434.317 2.69.647 3.613.204.571.423.962.617 1.192a.75.75 0 0 0 .209.189.75.75 0 0 0 .21-.19c.193-.229.412-.62.616-1.19.33-.925.57-2.18.647-3.614h-2.946zm2.946-2h-2.946c.077-1.435.317-2.69.647-3.613.204-.571.423-.962.617-1.192A.749.749 0 0 1 12 6.006a.749.749 0 0 1 .21.19c.193.229.412.62.616 1.19.33.924.57 2.18.647 3.614zm2.003 0c-.08-1.63-.35-3.12-.767-4.286a7.544 7.544 0 0 0-.03-.084A6.007 6.007 0 0 1 17.917 11h-2.441zm0 2h2.441a6.008 6.008 0 0 1-3.238 4.37l.03-.084c.417-1.166.688-2.656.767-4.286zm-6.952-2H6.083a6.007 6.007 0 0 1 3.238-4.37l-.03.084C8.873 7.88 8.602 9.37 8.523 11z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16GlobeLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16GlobeLine;
exports.default = _default;